import { useEffect } from 'react'
import { PaymentMethods, usePaymentOptions } from 'mmfintech-checkout-commons'
import { isSingleItemArray, isValidArray, tr } from 'mmfintech-commons'
import { PaymentMethodButton, PaymentMethodImage } from '../PaymentMethodButton'
import {
  PaymentMethodsContainer,
  PaymentMethodsEmpty,
  PaymentMethodsTitle,
  PaymentMethodsWrapper,
  SingleMethodName,
  SingleMethodWrapper
} from './SelectMethod.styled'
import { TrustlyPane } from '@components/TrustlyPane/TrustlyPane'

interface SelectMethodProps {
  className: string
  countryCode: string
  method: string
  setMethod: (value: string) => void
}

export const SelectMethod = (props: SelectMethodProps) => {
  const { className, countryCode, method, setMethod } = props

  const { paymentOptions, paymentOptionsFetching } = usePaymentOptions()

  useEffect(() => {
    if (isSingleItemArray(paymentOptions)) {
      setMethod(paymentOptions[0].paymentMethod)
    }
  }, [paymentOptions])

  if (isValidArray(paymentOptions)) {
    if (paymentOptions.length > 1) {
      return (
        <>
          <PaymentMethodsWrapper>
            <PaymentMethodsTitle>{tr('CHECKOUT.PAYMENT.METHOD_LABEL', 'Select payment method')}</PaymentMethodsTitle>
            <PaymentMethodsContainer className={className}>
              {paymentOptions.map(option => (
                <PaymentMethodButton
                  key={option.paymentMethod}
                  name={option.paymentMethod}
                  selected={method === option.paymentMethod}
                  onClick={() => setMethod(option.paymentMethod)}
                />
              ))}
            </PaymentMethodsContainer>
          </PaymentMethodsWrapper>

          {method === PaymentMethods.TRUSTLY && <TrustlyPane countryCode={countryCode} />}
        </>
      )
    }

    if (method) {
      return method === PaymentMethods.TRUSTLY ? (
        <TrustlyPane countryCode={countryCode} />
      ) : (
        <SingleMethodWrapper>
          <SingleMethodName>{tr(`METADATA.PAYMENT_OPTIONS.${method}`, method)}</SingleMethodName>
          <PaymentMethodImage method={method} className='icon' />
        </SingleMethodWrapper>
      )
    }

    return null
  }

  return paymentOptionsFetching ? null : (
    <PaymentMethodsWrapper>
      <PaymentMethodsEmpty>{tr('CHECKOUT.PAYMENT.NO_METHODS', 'No payment methods available')}</PaymentMethodsEmpty>
    </PaymentMethodsWrapper>
  )
}
